<template>
  <li :class="{ active: isOpen && !alwaysOpen }">
    <a
      href="#"
      class="acc-opener"
      :class="{ 'non-interactive': alwaysOpen }"
      @click.prevent="handleClick"
    >
      <span :class="['nav-icon', icon ? icon : '']"></span>
      <div class="nav-txt">{{ label }}</div>
      <span
        v-if="!alwaysOpen"
        class="nav-arrow"
        :class="{ 'arrow-up': isOpen }"
      >
        <i class="icon-arrow-down"></i>
      </span>
    </a>
    <ul class="nav_sub-list nav-list" v-show="isOpen">
      <slot></slot>
    </ul>
  </li>
</template>

<script>
export default {
  name: "NavLinkGroup",
  props: {
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.alwaysOpen || this.defaultOpen,
    };
  },
  watch: {
    defaultOpen(newVal) {
      if (!this.alwaysOpen) {
        this.isOpen = newVal;
      }
    },
    alwaysOpen(newVal) {
      if (newVal) {
        this.isOpen = true;
      }
    },
  },
  methods: {
    handleClick() {
      if (!this.alwaysOpen) {
        this.isOpen = !this.isOpen;
      }
    },
  },
};
</script>

<style scoped>
.nav-arrow {
  margin-left: auto;
  transition: transform 0.2s ease;
}

.nav-arrow.arrow-up {
  transform: rotate(180deg);
}

.nav_sub-list {
  padding-left: 20px;
}

.acc-opener.non-interactive {
  cursor: default;
}

.acc-opener.non-interactive:hover {
  background: transparent !important;
  color: inherit !important;
}
</style>
